// extracted by mini-css-extract-plugin
export default {"link":"styles_link__7ECv0","link--disabled":"styles_link--disabled__ht7qz"};